export default {
  navigationBarTitleText: '设置'
}
